import { resolvePd } from '@order/hooks/state/orderState'
import { useOrderState } from '@order/hooks/useOrderState'
import { useMemo } from 'react'

export const useResolvedPd = () => {
  const pd = useOrderState((s) => s.order.pd)

  return useMemo(() => resolvePd(pd), [pd])
}
